(() => {
  const C = window.SBEventCart;
  const F = window.SBEventFlow;
  function boot() {
    const C = window.SBEventCart;
    const F = window.SBEventFlow;
    document.querySelectorAll('[data-event-attendees]').forEach(root => {
      if (root.dataset.initialized || !C || !F) return;
      root.dataset.initialized = 'true';
      new Attendees(root, C, F).init();
    });
  }
  class Attendees {
    constructor(root, C, F) {
      this.root = root; this.C = C; this.F = F; this.config = F.config; this.messages = this.config.messages;
      this.form = root.querySelector('[data-attendee-form]');
      this.cards = root.querySelector('[data-attendee-cards]');
      this.error = root.querySelector('[data-attendee-error]');
      this.status = root.querySelector('[data-attendee-status]');
      this.submit = root.querySelector('[data-attendee-continue]');
      this.add = root.querySelector('[data-attendee-add]');
      this.review = root.querySelector('[data-attendee-review]');
      this.restore = root.querySelector('[data-attendee-restore]');
      this.client = new C.Client(this.config.root);
      this.saver = new C.Saver(this.client, state => this.persist(state), () => this.refresh());
      this.busy = false; this.ready = false; this.storageOK = true;
    }
    async init() {
      this.params = new URL(location.href).searchParams;
      try {
        this.cart = await this.client.read();
        const loaded = this.loadState();
        this.state = loaded.state;
        this.persist();
        this.render();
        this.bind();
        this.ready = true;
        this.update();
        if (loaded.error) this.showError(loaded.error);
        if (!this.config.purchasable) this.showError('unavailable', false);
        window.addEventListener('pageshow', event => { if (event.persisted) this.reloadAvailability(); });
      } catch (error) {
        this.showError('network', false);
        this.review.hidden = false;
        this.review.textContent = this.messages.retry;
        this.review.onclick = () => { this.review.onclick = null; this.review.hidden = true; this.init(); };
      }
    }
    loadState() {
      const { C, config, cart, params } = this;
      const requestedVariant = params.get('variant');
      let variantId = requestedVariant || config.variants.find(v => v.available)?.id || config.variants[0]?.id || '';
      let groupId = params.get('group');
      const recentKey = `sb-event-recent:${config.eventId}:${variantId}`;
      try { if (!groupId && !params.has('legacy')) groupId = sessionStorage.getItem(recentKey); } catch { this.storageOK = false; }
      if (!groupId && !params.has('legacy')) groupId = cart.items.find(item => C.ticket(item, config) && String(item.variant_id) === String(variantId) && item.properties?.[C.P.group])?.properties[C.P.group];
      if (!groupId || !/^[a-zA-Z0-9-]{1,80}$/.test(groupId)) groupId = C.uuid();
      let stored;
      try { stored = JSON.parse(sessionStorage.getItem(`sb-event-draft:${config.eventId}:${groupId}`) || 'null'); } catch { this.storageOK = false; }
      const rows = C.members(cart, { groupId, eventId: config.eventId });
      if (!requestedVariant && rows.length) variantId = String(rows[0].variant_id);
      const existing = C.fromCart(cart, groupId, config.eventId);
      let state = stored?.eventId === config.eventId && Array.isArray(stored.attendees) ? stored : { eventId: config.eventId, groupId, variantId, attendees: existing, legacyKeys: [] };
      state.variantId = variantId;
      let issue = '';
      if (params.has('legacy') && !state.pending) {
        const item = cart.items.find(item => item.key === params.get('legacy') && C.ticket(item, config) && !item.properties?.[C.P.group]);
        if (item) {
          state.legacyKeys = [item.key];
          state.variantId = String(item.variant_id);
          if (!stored) state.attendees = Array.from({ length: Math.min(item.quantity, 100) }, () => ({ id: C.uuid(), first: '', last: '', properties: item.properties || {} }));
        } else if (!rows.length) issue = 'not_selected';
      }
      if (state.base === undefined) state.base = C.fingerprint(cart, state);
      if (!stored?.pending && stored && state.base !== C.fingerprint(cart, state)) { issue = 'conflict'; this.conflicted = true; }
      const quantity = Number(params.get('quantity'));
      if (!state.attendees.length) {
        const count = params.has('quantity') && Number.isInteger(quantity) && quantity >= 1 && quantity <= config.maxQuantity ? quantity : 1;
        state.attendees = Array.from({ length: count }, () => ({ id: C.uuid(), first: '', last: '' }));
      } else if (params.has('quantity') && Number.isInteger(quantity) && quantity >= 1 && quantity <= config.maxQuantity && !state.pending) {
        while (state.attendees.length < quantity) state.attendees.push({ id: C.uuid(), first: '', last: '' });
        if (quantity < state.attendees.length) issue = 'quantity';
      }
      if (params.has('quantity') && (!Number.isInteger(quantity) || quantity < 1 || quantity > config.maxQuantity)) issue = 'quantity';
      if (params.get('add') === '1' && !state.pending && state.attendees.length < config.maxQuantity) state.attendees.push({ id: C.uuid(), first: '', last: '' });
      if (this.conflicted) issue = 'conflict';
      const canonical = new URL(this.F.url('attendees', { group: groupId, variant: state.variantId }), location.origin);
      history.replaceState(history.state, '', canonical.pathname + canonical.search);
      this.storageKey = `sb-event-draft:${config.eventId}:${groupId}`;
      this.recentKey = `sb-event-recent:${config.eventId}:${state.variantId}`;
      return { state, error: issue };
    }
    persist(state = this.state) {
      if (!state) return;
      try {
        sessionStorage.setItem(this.storageKey, JSON.stringify(state));
        sessionStorage.setItem(this.recentKey, state.groupId);
      } catch { this.storageOK = false; }
    }
    bind() {
      this.form.addEventListener('submit', event => { event.preventDefault(); this.save(); });
      this.cards.addEventListener('input', event => {
        const input = event.target.closest('[data-name]');
        if (!input) return;
        const person = this.state.attendees.find(p => p.id === input.closest('[data-person]').dataset.person);
        person[input.dataset.name] = input.value;
        this.state.saved = false;
        input.removeAttribute('aria-invalid');
        this.root.querySelector(`[id="${input.getAttribute('aria-describedby')}"]`).hidden = true;
        this.persist();
      });
      this.add.addEventListener('click', () => {
        if (this.busy || this.state.pending || this.state.attendees.length >= this.maximum()) return;
        const person = { id: this.C.uuid(), first: '', last: '' };
        this.state.attendees.push(person); this.state.saved = false; this.persist(); this.render(); this.focusPerson(person.id);
      });
      this.cards.addEventListener('click', event => {
        const button = event.target.closest('[data-attendee-remove]');
        if (!button || this.busy || this.state.pending || this.state.attendees.length < 2) return;
        const id = button.closest('[data-person]').dataset.person;
        const index = this.state.attendees.findIndex(person => person.id === id);
        const [person] = this.state.attendees.splice(index, 1);
        this.state.undo = { person, index };
        this.state.saved = false; this.persist(); this.render();
        this.focusPerson(this.state.attendees[Math.min(index, this.state.attendees.length - 1)].id);
      });
      this.root.querySelector('[data-undo]').addEventListener('click', () => {
        if (!this.state.undo || this.busy || this.state.pending || this.state.attendees.length >= this.maximum()) return;
        const { person, index } = this.state.undo;
        this.state.attendees.splice(index, 0, person); this.state.undo = null;
        this.state.saved = false; this.persist(); this.render(); this.focusPerson(person.id);
      });
      this.review.addEventListener('click', () => this.reviewCart());
      this.restore.addEventListener('click', () => {
        if (this.busy || this.state.pending || this.conflicted || !this.state.recoveryDraft) return;
        const current = new Map(this.state.attendees.map(person => [person.id, person]));
        this.state.attendees = this.state.recoveryDraft.map(person => ({ ...person, properties: current.get(person.id)?.properties || person.properties }));
        this.state.recoveryDraft = null;
        this.state.saved = false; this.persist(); this.render(); this.focusPerson(this.state.attendees[0].id);
      });
    }
    render() {
      this.cards.replaceChildren();
      this.state.attendees.forEach((person, index) => {
        const fragment = this.root.querySelector('[data-attendee-template]').content.cloneNode(true);
        const card = fragment.querySelector('fieldset'); card.dataset.person = person.id;
        const label = this.messages.attendee.replace('[number]', index + 1);
        fragment.querySelector('[data-attendee-legend]').textContent = label;
        fragment.querySelector('[data-attendee-heading]').textContent = label;
        const remove = fragment.querySelector('[data-attendee-remove]');
        remove.setAttribute('aria-label', `${this.messages.remove}: ${label}`);
        remove.disabled = this.state.attendees.length === 1;
        ['first', 'last'].forEach(name => {
          const input = fragment.querySelector(`[data-name="${name}"]`);
          const id = `attendee-${person.id}-${name}`;
          input.id = id; input.value = person[name];
          input.setAttribute('autocomplete', `section-${person.id} ${name === 'first' ? 'given-name' : 'family-name'}`);
          input.setAttribute('aria-describedby', id + '-error');
          fragment.querySelector(`[data-${name}-label]`).htmlFor = id;
          fragment.querySelector(`[data-${name}-error]`).id = id + '-error';
        });
        this.cards.append(fragment);
      });
      this.update();
    }
    maximum() { return this.config.purchasable ? this.C.allowance(this.cart, this.state, this.config) : this.config.maxQuantity; }
    update() {
      const variant = this.config.variants.find(v => String(v.id) === String(this.state.variantId));
      const displayPrice = variant?.price ?? this.config.previewPrice;
      this.root.querySelector('[data-attendee-count]').textContent = String(this.state.attendees.length);
      this.root.querySelector('[data-attendee-type]').textContent = variant?.title || this.messages.general_admission;
      this.root.querySelector('[data-attendee-total]').textContent = displayPrice != null ? new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency }).format(displayPrice * this.state.attendees.length / 100) : this.messages.price_unavailable;
      this.root.querySelectorAll('[data-event-back]').forEach(link => { link.href = this.F.url('events', { group: this.state.groupId, variant: this.state.variantId, quantity: this.state.attendees.length }); });
      const locked = this.busy || !!this.state.pending;
      this.cards.querySelectorAll('input, button').forEach(el => { el.disabled = locked || (el.matches('[data-attendee-remove]') && this.state.attendees.length === 1); });
      this.add.disabled = !this.ready || locked || this.conflicted || this.state.attendees.length >= this.maximum();
      this.submit.disabled = !this.ready || this.busy || this.conflicted || !this.config.purchasable;
      this.submit.firstChild.textContent = (this.busy ? this.messages.saving : this.state.pending ? this.messages.retry : this.messages.continue) + ' ';
      this.form.setAttribute('aria-busy', String(this.busy));
      this.root.querySelector('[data-attendee-undo]').hidden = !this.state.undo;
      this.root.querySelector('[data-undo]').disabled = locked || this.state.attendees.length >= this.maximum();
      this.review.hidden = !this.conflicted;
      this.restore.hidden = !this.state.recoveryDraft;
      this.restore.disabled = locked || this.conflicted;
      this.status.textContent = !this.storageOK ? this.messages.storage : this.busy ? this.messages.saving : '';
    }
    focusPerson(id) { this.cards.querySelector(`[data-person="${id}"] input`)?.focus(); }
    showError(code, focus = true) {
      const keys = { quantity: 'quantity_error', unsupportedRules: 'unsupported_rules', required: 'required' };
      this.error.textContent = this.messages[keys[code] || code] || this.messages.network;
      this.error.hidden = false;
      if (focus) this.error.focus();
    }
    validate() {
      let firstInvalid;
      this.state.attendees.forEach(person => ['first', 'last'].forEach(name => {
        person[name] = this.C.clean(person[name]);
        const input = this.cards.querySelector(`[id="attendee-${person.id}-${name}"]`);
        input.value = person[name];
        if (!person[name]) {
          input.setAttribute('aria-invalid', 'true');
          const message = this.root.querySelector(`[id="${input.getAttribute('aria-describedby')}"]`);
          message.textContent = this.messages.required; message.hidden = false;
          firstInvalid ||= input;
        }
      }));
      this.persist();
      if (firstInvalid) { this.showError('required', false); firstInvalid.focus(); return false; }
      return true;
    }
    async refresh() { this.config = await this.F.refresh(); return this.config; }
    async reloadAvailability() {
      if (this.busy) return;
      try { await this.refresh(); this.cart = await this.client.read(); this.update(); }
      catch { this.showError('network', false); }
    }
    async reviewCart() {
      if (this.busy) return;
      try {
        this.cart = await this.client.read();
        const live = this.C.fromCart(this.cart, this.state.groupId, this.state.eventId);
        this.state.recoveryDraft = this.state.attendees;
        this.state.attendees = live.length ? live : this.state.attendees;
        this.state.base = this.C.fingerprint(this.cart, this.state);
        this.state.pending = null; this.conflicted = false;
        this.persist(); this.error.hidden = true; this.render();
        this.focusPerson(this.state.attendees[0].id);
      } catch { this.showError('network'); }
    }
    async save() {
      if (this.busy || this.conflicted || !this.validate()) return;
      this.busy = true; this.error.hidden = true; this.update();
      try {
        const run = async () => this.saver.save(this.state, { first: this.messages.first, last: this.messages.last });
        const result = navigator.locks ? await navigator.locks.request(`sb-event:${this.state.groupId}`, run) : await run();
        this.cart = result.cart;
        const invalid = this.C.invalidGroup(result.cart, result.config);
        if (invalid) {
          location.assign(this.F.url('attendees', { variant: invalid.variant_id, group: invalid.properties?.[this.C.P.group], legacy: invalid.properties?.[this.C.P.group] ? '' : invalid.key }));
        } else { this.C.checkCart(result.cart, result.config); location.assign(result.config.root + 'checkout'); }
      } catch (error) {
        if (error.code === 'conflict') this.conflicted = true;
        this.showError(error.code || 'network');
        try { this.cart = await this.client.read(); } catch {}
      } finally { this.busy = false; this.persist(); this.update(); }
    }
  }
  document.addEventListener('shopify:section:load', boot);
  if (!C || !F) document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
